import { http } from './http'

// === Справочник офицеров для выпадающего списка ===
// Backend endpoint is GET-only.
export async function listCommanders(params = {}) {
  const { data } = await http.get('users/commanders/', { params })
  return data
}

// === 7 раздел. Учет работы офицеров (CRUD в рамках book-контекста) ===
export async function listOfficersWork(params = {}) {
  const { data } = await http.get('book/officers-work/', { params })
  return data
}

export async function getOfficerWork(id) {
  const { data } = await http.get(`book/officers-work/${id}/`)
  return data
}

export async function createOfficerWork(payload) {
  const { data } = await http.post('book/officers-work/', payload)
  return data
}

export async function updateOfficerWork(id, payload) {
  const { data } = await http.patch(`book/officers-work/${id}/`, payload)
  return data
}

export async function deleteOfficerWork(id) {
  const { data } = await http.delete(`book/officers-work/${id}/`)
  return data
}

/**
 * Сохраняет набор записей: создает новые, обновляет существующие и удаляет снятые.
 * rows — массив записей из UI (новые не имеют id).
 */
export async function saveOfficersWork(rows = []) {
  // загрузим текущие записи с сервера, чтобы определить удаления
  const existing = await listOfficersWork();
  const existingIds = new Set(existing.map(e => e.id));
  const incomingIds = new Set(rows.filter(r => r.id).map(r => r.id));

  const deletePromises = existing
    .filter(e => !incomingIds.has(e.id))
    .map(e => deleteOfficerWork(e.id));

  const upsertPromises = rows.map(r => {
    const payload = { ...r };
    // удаляем служебные поля, которые сервер не ждет
    delete payload.__id;
    delete payload.officerKey;

    if (r.id) {
      return updateOfficerWork(r.id, payload);
    } else {
      return createOfficerWork(payload);
    }
  });

  await Promise.all([...deletePromises, ...upsertPromises]);

  // вернуть актуальный список
  return listOfficersWork();
}
